<script>
import { ref } from 'vue';
import { TemplateAnnotations, PageEditorBridge } from '@magnolia/template-annotations';
import { insertComments, mgnlRender, removeComments } from './helper';
import PersonalizationService from './PersonalizationService';
import EditorContextHelper from './EditorContextHelper';

const EditablePage = {
  name: 'EditablePage',
  props: {
    content: { type: Object },
    config: {
      type: Object,
      required: true
    },
    templateAnnotations: { type: Object }
  },
  setup(props) {
    let reactiveTemplateAnnotations = {};
    if (props.templateAnnotations) {
      reactiveTemplateAnnotations = ref({ value: props.templateAnnotations });
    }
    return {
      reactiveTemplateAnnotations
    };
  },
  data() {
    return {
      selectedComponentVariants: '',
      listeners: {}
    };
  },
  computed: {
    renderingContent() {
      const generatedAreasContent = TemplateAnnotations.generateMissingAreas(
        this.content,
        this.reactiveTemplateAnnotations.value
      );
      return PersonalizationService.getVariant(
        generatedAreasContent,
        this.reactiveTemplateAnnotations.value
      );
    }
  },
  methods: {
    writeAnnotation() {
      if (!this.content) {
        return;
      }
      if (
        this.reactiveTemplateAnnotations.value &&
        this.reactiveTemplateAnnotations.value[this.renderingContent['@path']]
      ) {
        removeComments(this.$el);
        const commentOpen = this.reactiveTemplateAnnotations.value[this.renderingContent['@path']];
        insertComments(this.$el, commentOpen, '/cms:page');
        EditorContextHelper.onFrameReady();
        EditorContextHelper.refresh();
      }
    },
    updateTemplateAnnotationsProvider() {
      this.reactiveTemplateAnnotations.value = PersonalizationService.wrap(
        this.templateAnnotations,
        this.selectedComponentVariants
      );
    }
  },
  provide() {
    return {
      config: this.config,
      templateAnnotations: this.reactiveTemplateAnnotations
    };
  },
  mounted() {
    if (EditorContextHelper.inIframe()) {
      PageEditorBridge.onMessage(this.listeners, 'updateState', (message) => {
        this.selectedComponentVariants = message.selectedComponentVariants;
        this.updateTemplateAnnotationsProvider();
      });
      PageEditorBridge.init(this.listeners);
      this.writeAnnotation();
    }
  },
  beforeUpdate() {
    if (EditorContextHelper.inIframe()) {
      this.updateTemplateAnnotationsProvider();
      this.writeAnnotation();
    }
  },
  render() {
    return mgnlRender(
      this.renderingContent,
      this.config.componentMappings,
      this.config.fallbackComponent
    );
  }
};

export default EditablePage;
</script>
